import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaUser } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import { BASE_URL } from "../../constants";

function UnavailableUsersCard() {
  const [totalUnavailableUsers, setTotalUnavailableUsers] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUnavailableUsers = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/refugees/users/availability`);


        // Directly read the totalNotAvailable field
        setTotalUnavailableUsers(response.data.allTotals.totalNotAvailable);
      } catch (error) {
        console.error("Error fetching unavailable users:", error);
        setTotalUnavailableUsers(0);
      } finally {
        setLoading(false);
      }
    };

    fetchUnavailableUsers();
  }, []);

  return (
<div
  style={{
    background: "linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%)", // keep red
    borderRadius: "12px",
    color: "white",
    padding: "20px", 
    boxShadow: "0px 19px 60px rgb(0 0 0 / 8%)", // same as others
  }}
  className="hover-scale w-100"
>
  <div className="card-body p-2">
    <div className="d-flex justify-content-between align-items-center flex-wrap">
      <FaUser
        size={30}
        style={{
          stroke: "white",
          strokeWidth: "10px",
          filter: "drop-shadow(1px 2px 3px rgba(255, 255, 255, 0.5))",
        }}
      />

      <h6
        className="fw-bold mb-1 text-white text-truncate"
        style={{ fontSize: "1.2rem", minWidth: "120px" }}
      >
        {loading ? "..." : `${totalUnavailableUsers} Unavailable Users`}
      </h6>
    </div>
    <small
      className="text-white-40 d-block mt-1"
      style={{ fontSize: "0.85rem" }}
    >
      {loading ? "..." : "Total unavailable users across all shelters."}
    </small>
  </div>
</div>


  );
}

export default UnavailableUsersCard;
